import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule, NgIf, NgFor } from '@angular/common';
import { environment } from '../../../environments/environment';
import { DownloadRota, LayoutIndicadoresService } from './layout-indicadores.service';

@Component({
  selector: 'app-layout-indicadores',
  standalone: true,
  imports: [RouterModule, NgIf, CommonModule],
  templateUrl: './layout-indicadores.component.html',
  styleUrl: './layout-indicadores.component.scss'
})
export class LayoutIndicadoresComponent {
  urlBase = `${environment.apiUrl}`;

  corBordaTag: string = '';
  corTextoTag: string = '';
  tituloTag: string = '';
  editavel: boolean = false;

  redeSelecionada: string = '';
  pais: string = '';
  estado: string = '';
  siglaEstado: string = '';
  cidade: string = '';
  ano: string = '';

  rotaResultado: string = '';
  rotaFiltroLocalidade: string = '';
  rotaDownloadIndicadores: DownloadRota | null = null;
  rotaApresentacao: string = '';
  rotaEdicaoSimulacao: string = '';

  textoComoCitar: string = '';

  imagemFundo: string = 'assets/ilustrations/bridge-mountain.svg';

  constructor(public layoutIndicadoresService: LayoutIndicadoresService) {
    layoutIndicadoresService.getTituloTag().subscribe(tituloTag => {
      this.tituloTag = tituloTag
    });
    layoutIndicadoresService.getCorBordaTag().subscribe(corBordaTag => {
      this.corBordaTag = corBordaTag
    });
    layoutIndicadoresService.getCorTextoTag().subscribe(corTextoTag => {
      this.corTextoTag = corTextoTag
    });
    layoutIndicadoresService.getEditavel().subscribe(editavel => {
      this.editavel = editavel
    });

    layoutIndicadoresService.getRedeSelecionada().subscribe(redeSelecionada => {
      this.redeSelecionada = redeSelecionada
    });
    layoutIndicadoresService.getPais().subscribe(pais => {
      this.pais = pais
    });
    layoutIndicadoresService.getEstado().subscribe(estado => {
      this.estado = estado
    });
    layoutIndicadoresService.getSiglaEstado().subscribe(siglaEstado => {
      this.siglaEstado = siglaEstado
    });
    layoutIndicadoresService.getCidade().subscribe(cidade => {
      this.cidade = cidade
    });
    layoutIndicadoresService.getAno().subscribe(ano => {
      this.ano = ano
    });

    layoutIndicadoresService.getRotaResultado().subscribe(rotaResultado => {
      this.rotaResultado = rotaResultado
    });
    layoutIndicadoresService.getRotaFiltroLocalidade().subscribe(rotaFiltroLocalidade => {
      this.rotaFiltroLocalidade = rotaFiltroLocalidade
    });
    layoutIndicadoresService.getRotaDownloadIndicadores().subscribe(rotaDownloadIndicadores => {
      this.rotaDownloadIndicadores = rotaDownloadIndicadores
    });
    layoutIndicadoresService.getRotaApresentacao().subscribe(rotaApresentacao => {
      this.rotaApresentacao = rotaApresentacao
    });
    layoutIndicadoresService.getRotaEdicaoSimulacao().subscribe(rotaEdicaoSimulacao => {
      this.rotaEdicaoSimulacao = rotaEdicaoSimulacao
    });

    layoutIndicadoresService.getTextoComoCitar().subscribe(textoComoCitar => {
      this.textoComoCitar = textoComoCitar
    });

    this.layoutIndicadoresService.getImagemFundo().subscribe((imagemFundo) => {
      this.imagemFundo = imagemFundo;
    });
  }

  abrirEdicaoSimulacao() {
    if (this.rotaEdicaoSimulacao) {
      location.assign(this.rotaEdicaoSimulacao);
    }
  }

  async copiarParaAreaDeTransferencia() {
    try {
      await navigator.clipboard.writeText(this.textoComoCitar);
    } catch (err) {
      console.error('Falha ao copiar o texto para a área de transferência', err);
    }
  }

  get isNivelMunicipal(): boolean {
    return !!(this.cidade);
  }

  get isNivelEstadual(): boolean {
    return !!(this.estado && !this.cidade);
  }

  get isNivelNacional(): boolean {
    return !!(this.pais && !this.estado && !this.cidade);
  }

}
